<div *ngIf="!isMobile">
<section class="banner" *ngFor="let post of posts$ | async">
    <div class="container-fluid h-100">
        <div class="row h-100 content-center align-items-center">
            <div class="col-md-6 banner-image">
                <img [src]="post.acf.imagen_fondo.url" alt="Banner Image" class="img-fluid">
            </div>
            <div class="col-md-6 banner-content">
                <h2 [innerHTML]='post.acf.titulo'></h2>
                <div class="bajadaDes" [innerHTML]='post.acf.bajada'></div>
            </div>
        </div>
    </div>
</section>
</div>

<div *ngIf="isMobile">
<section class="banner" *ngFor="let post of posts$ | async" [ngStyle]="{'background-image':'url(' + post.acf.imagenmobile + ')'}">
    <div class="fondo"></div>
    <div class="container h-100 ">
        <div class="row h-100 banner-content content-end justify-content-end align-items-end">
            <div class="col ">
                <h2 [innerHTML]='post.acf.titulo'></h2>
                <p class="bajadaDes" [innerHTML]='post.acf.bajada'></p>              
            </div>
        </div>
    </div>
</section>
</div>